import React, { useState } from 'react';
import { getWhatsAppUrl, getEmailUrl, getPhoneUrl } from '../utils/contact';
import '../ContactForm.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    orgType: '',
    interest: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/leads`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          source: 'landing',
          page: '/contact'
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          orgType: '',
          interest: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container split-section">
          <div>
            <p className="eyebrow">Contact</p>
            <h1>Let’s help you choose the right solution.</h1>
            <p className="section-intro left">
              Share your goals and we will guide you to the best product or service. You can reach
              us instantly via WhatsApp, or send a detailed request using the form.
            </p>
            <div className="cta-buttons">
              <a href={getWhatsAppUrl('Hello ProgrammoCeuticals, I need assistance')} className="btn btn-primary">Chat on WhatsApp</a>
              <a href={getPhoneUrl()} className="btn btn-secondary">Call Us</a>
            </div>
          </div>
          <div className="section-visual">
            <img src="/images/health-lagos.jpg" alt="Nigerian healthcare professional using technology" />
          </div>
        </div>
      </section>

      <section className="contact-main section-surface">
        <div className="container">
          <div className="contact-content">
            <div className="contact-methods">
              <h2>Direct Contact</h2>
              <p className="section-intro left">
                Choose the fastest channel for your request.
              </p>
              
              <div className="contact-cards">
                <div className="contact-card">
                  <h3>WhatsApp</h3>
                  <p>Quick responses and instant communication.</p>
                  <a href={getWhatsAppUrl('Hello ProgrammoCeuticals, I need assistance')} className="btn btn-primary">Chat Now</a>
                </div>
                
                <div className="contact-card">
                  <h3>Phone</h3>
                  <p>Speak directly with our team.</p>
                  <a href={getPhoneUrl()} className="btn btn-secondary">+234 903 378 2254</a>
                </div>
                
                <div className="contact-card">
                  <h3>Email</h3>
                  <p>Detailed inquiries and documentation.</p>
                  <a href={getEmailUrl('General Inquiry')} className="btn btn-tertiary">info@programmoceuticals.com</a>
                </div>
              </div>
            </div>
            
            <div className="contact-form-section">
              <h2>Send us a Message</h2>
              <p className="section-intro left">
                We typically respond within 1–2 business days.
              </p>
              
              {submitStatus === 'success' && (
                <div className="success-message">
                  <p>Thank you for your message! We will reach out within 1-2 business days.</p>
                  <a href={getWhatsAppUrl('I just submitted a contact form and would like to discuss further')} className="btn btn-primary">Continue on WhatsApp</a>
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="error-message">
                  <p>There was an error submitting your message. Please try again or contact us directly.</p>
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="fullName">Full Name *</label>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                      minLength={2}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone (optional)</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+234..."
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="orgType">Organization Type *</label>
                    <select
                      id="orgType"
                      name="orgType"
                      value={formData.orgType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select...</option>
                      <option value="Student">Student</option>
                      <option value="Faculty">Faculty</option>
                      <option value="Industry">Industry</option>
                      <option value="Regulatory">Regulatory</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="interest">Interested In *</label>
                    <select
                      id="interest"
                      name="interest"
                      value={formData.interest}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select...</option>
                      <option value="Dossier">Dossier Compiler</option>
                      <option value="School">School Platform</option>
                      <option value="Regulations">Regulations Hub</option>
                      <option value="Consulting">Consulting Services</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    minLength={10}
                    rows={5}
                    placeholder="Tell us about your needs and how we can help..."
                  />
                </div>
                
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
